module.exports = __webpack_public_path__ + "media/assets/images/flags/ml-73189c264dfe856f16616201d5f39bf3.svg";